/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountDto { 
    id?: number;
    accountNumber?: string | null;
    name?: string | null;
    accountCode?: string | null;
    type?: string | null;
    isDefault?: boolean;
    balance?: number;
    openingBalance?: number;
    typeId?: number | null;
    title?: string | null;
    accountName?: string | null;
    memberName?: string | null;
    tenantId?: number | null;
    closingBalance?: number;
    debit?: number | null;
    credit?: number | null;
    blocked?: number | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    referenceId?: string | null;
    creationTime?: string;
}

